import axios from 'axios';

// constants
import { API_URL_NEW } from '../lib/endpoints'

// helpers
import { prepareFilterParam, prepareSelectParam } from '../lib/queryParams';

// common functions for all entities

const entityApi = {

    getUserTeamStatus: (entityId, entityType) => {
        const url = `${API_URL_NEW}/${entityType}/${entityId}/team-membership-status`;

        return new Promise((resolve, reject) => {
            axios.get(url).then((response) => {
                resolve(response.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },

    getRelatedNews: (entityId, entityType) => {
        const url = `${API_URL_NEW}/${entityType}/${entityId}/news`;
        return new Promise((resolve, reject) => {
            axios.get(url).then((response) => {
                resolve(response.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },

    getCompanyEmail: (entityId, entityType) => {
        const fields = prepareSelectParam(["email_relations"]);

        const url = `${API_URL_NEW}/${entityType}/${entityId}?fields=${fields}`;

        return new Promise((resolve, reject) => {
            axios.get(url).then((response) => {
                resolve(response.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },

    getRestrictedProfileData: (entityId, entityType) => {
        const fields = prepareSelectParam([
            'fund_raised_data',
            'estimated_deployed_startup',
            'estimated_deployed_fund',
            'number_of_pe_investments',
            'number_of_startups',
            'last_date_invested',
            'geo_focus_data',
            'date_founded',
            'development_stage_data',
            'estimated_deployed_capital',
            'min_ticket_size',
            'max_ticket_size',
            'ticket_size_range',
            'median_deal_size',
            'median_valuation',
            'number_of_active_entities',
            'number_of_entities',
            'investments_ttm',
            'first_date_invested',
            'fund_of_fund_total_amount_raised',
            'number_of_funds',
            'number_of_lps',
            'number_of_investments',
            'number_of_exits',
            'email_relations'
        ]);

        const url = `${API_URL_NEW}/${entityType}/${entityId}?fields=${fields}`;

        return new Promise((resolve, reject) => {
            axios.get(url).then((response) => {
                resolve(response.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },

    getEntityName: (entityId = null, entityType = null) => {
        const fields = prepareSelectParam(["name", "id"]); // id is required for saved filter (getFilterByKey function)

        const url = `${API_URL_NEW}/${entityType}/${entityId}?fields=${fields}`;

        return new Promise((resolve, reject) => {
            axios.get(url).then((response) => {
                resolve(response.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },

    getEntityDetails: (entityId, entityType,fieldsArr) => {
        const fields = prepareSelectParam(fieldsArr);
        const url = `${API_URL_NEW}/${entityType}/${entityId}?fields=${fields}`;

        return new Promise((resolve, reject) => {
            axios.get(url).then((response) => {
                const resp = response.data.data;
                if (response.data.status == 200 && resp.id) {
                    resolve(resp);
                }
            }).catch(error => {
                reject(error);
            })
        });
    },

    getInvestors: (entityId, entityType, limit = 6, page = 1, getFilters = []) => {
        let filterQuery = '';
        if (getFilters && getFilters.length > 0) {
            filterQuery = `filters=${prepareFilterParam(getFilters)}&`;
        }
        const url = `${API_URL_NEW}/${entityType}/${entityId}/investor?${filterQuery}limit=${limit}&page=${page}`;

        return new Promise((resolve, reject) => {
            if (entityType && entityId) {
                axios.get(url).then((response) => {
                    const list = response.data.data;
                    resolve({
                        records: list,
                        totalRecords: response.data.navigation.total
                    });
                }).catch(err => {
                    reject(err)
                })
            } else {
                resolve({ records: [], totalRecords: 0 })
            }
        });
    },
}

export default entityApi;
